/**
 * Error Handling Utilities
 *
 * Centralized error tracking, user-friendly error display, and error message extraction.
 */

import * as Sentry from '@sentry/nextjs'
import { toast } from 'sonner'

export const isDevelopment = process.env.NODE_ENV === 'development'

/**
 * Track error to Sentry and console.
 */
export function trackError(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  Sentry.captureException(error, { extra: context })
  console.error('[Error]', error, context ? { context } : '')
}

/**
 * Show user-friendly error toast notification.
 */
export function showErrorToast(message: string): void {
  toast.error(message)
}

/**
 * Combined: track error + show user-friendly toast message.
 */
export function handleError(
  error: unknown,
  userMessage: string,
  context?: Record<string, unknown>,
): void {
  trackError(error, context)
  showErrorToast(userMessage)
}

/**
 * Extract a human-readable error message from an unknown error.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return 'An unexpected error occurred'
}
